import React from 'react';

import SkeletonHitCard from 'Components/Card/HitCard/SkeletonHitCard';
import SkeletonBlock from 'Components/Skeleton/SkeletonBlock';

// The filter sidebar's rows (SearchFilters): On Sale, then Price (open by default), then closed toggles
const FILTERS = ['on-sale', 'price', 'type', 'platform', 'genre', 'features', 'os', 'steam-deck'];

/**
 * Search page while it loads: SearchPage's ProductListing, with the title and controls, and from lg the filter
 * sidebar open beside a 2 column (3 at xl) grid. Below lg the filters are closed: a 2/3 column grid. The query is in
 * the URL, but the title around it is translated, so no slots.
 */
export default function SearchPageSkeleton() {
  return (
    <section className="container SearchPageSkeleton">
      <SkeletonBlock className="SearchPageSkeleton__title" />

      <div className="SearchPageSkeleton__controls">
        <div className="SearchPageSkeleton__controlGroup">
          <SkeletonBlock className="SearchPageSkeleton__button SearchPageSkeleton__button--filter" />
          <SkeletonBlock className="SearchPageSkeleton__showing d-none d-lg-block" />
        </div>
        <div className="SearchPageSkeleton__controlGroup">
          <SkeletonBlock className="SearchPageSkeleton__button d-none d-lg-block" />
          <SkeletonBlock className="SearchPageSkeleton__button SearchPageSkeleton__button--sort" />
        </div>
      </div>

      <div className="SearchPageSkeleton__main">
        <div className="SearchPageSkeleton__filters d-none d-lg-block">
          {FILTERS.map(filter =>
            <div className="SearchPageSkeleton__filter" key={filter}>
              <SkeletonBlock className="SearchPageSkeleton__filterLabel" />
              {filter === 'price' &&
                <SkeletonBlock className="SearchPageSkeleton__filterOptions" />
              }
            </div>,
          )}
        </div>

        <div className="SearchPageSkeleton__grid">
          {/* As ProductListingHits renders while searching */}
          <SkeletonHitCard
            ProductListing
            numberOfCards={12}
            xsSize={12}
            smSize={12}
            mdSize={12}
            lgSize={12}
          />
        </div>
      </div>
    </section>
  );
}
